module.exports = __webpack_public_path__ + "static/img/ent-66.8d3c686.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-66.jpg
// module id = rhkR
// module chunks = 52